module.exports = __webpack_public_path__ + "img/privilege1.5af006e1.png";